export default __webpack_public_path__ + "svgs/referral-widget-41489248.svg";